// Tutorial data for Data Loading tutorial (Tutorial 3)
// This dynamically loads the actual .txt/.dat files using file processing functions

import Ellipsometry from './TutorialData_Ellips.txt';
import Literature_n from './TutorialData_n.csv';
import ReflectivityCaF2 from './TutorialData_R_CaF2.txt';
import ReflectivityKBr from './TutorialData_R_KBr.dat';

// Helper function to create a single file
const createSingleFile = async (fileUrl, fileName) => {
  const response = await fetch(fileUrl);
  const content = await response.text();

  return new File(
    [content],
    fileName,
    {
      type: fileUrl.endsWith('.dat') ? 'application/octet-stream' : 'text/plain',
      lastModified: Date.now()
    }
  );
};

// Function to create all tutorial files at once
export const createTutorial3Files = async () => {
  try {
    const files = await Promise.all([
      createSingleFile(Ellipsometry, 'Ellips_Tutorial.txt'),
      createSingleFile(Literature_n, 'n_Tutorial.csv'),
      createSingleFile(ReflectivityCaF2, 'R_CaF2_Tutorial.txt'),
      createSingleFile(ReflectivityKBr, 'R_KBr_Tutorial.dat'),
    ]);
    return files;
  } catch (error) {
    console.error('Error loading tutorial data files:', error);
    throw error;
  }
};

export default {
  createTutorial3Files
};
